"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPaymentMethodSchemaFieldType = void 0;
exports.CustomPaymentMethodSchemaFieldType = {
    Text: "text",
    Number: "number",
    Select: "select",
    Date: "date",
    Phone: "phone",
    Email: "email",
    Url: "url",
    Address: "address",
    UsBankRoutingNumber: "usBankRoutingNumber",
    UsBankAccountNumber: "usBankAccountNumber",
};
